<template>
  <div class="menu-management">
    <breadCrumb></breadCrumb>
    <base-table :tableData="tableData" @handleClick="handleClick"></base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    > </pagination>
  </div>
</template>

<script>
import pagination from "../../../../components/pagination"
  import baseTable from "../../../../components/baseTable";
  import breadCrumb from "../../../../components/breadCrumb";
  import { permissionPage } from "../../../../api/admin";
  export default {
    name: "menuFirst",
    components:{
      baseTable,
      pagination,
      breadCrumb
    },
    data(){
      return{
         paginationDataProduct: {
          total: 0,
          currentPage: 1,
          pageSize: 10
        },
        tableData:{
          tableHeader:[{
            prop:'id',
            label:'菜单ID',
          },{
            prop:'name',
            label:'菜单名称',
          },{
            prop:'permissionLevel',
            label:'层级',
          },{
            prop:'createTime',
            label:'创建时间',
          },{
            prop:'createMan',
            label:'创建人',
          },],
          tableList:[],
          tableType:2,
        }
      }
    },
    created(){
      
      this.permissionPage()
    },
    methods:{
      paginationChangeProduct(val){
        
        this.paginationDataProduct = val
        this.permissionPage()
      },
      handleClick(val){
        
        this.$router.push({
          path:'second',
          query: val.val
        })
      },
      permissionPage(){
        let vm = this
        permissionPage({
          page:this.paginationDataProduct.currentPage,
          pageSize:this.paginationDataProduct.pageSize,
          permissionLevel:1,
          pin: -1
        })
        .then(res => {
          console.log(res, 999);
          vm.tableData.tableList.splice(0,vm.tableData.tableList.length)
          res.data.map(item => {
            vm.tableData.tableList.push(item)
          })
          vm.paginationDataProduct.total = res.totalCount 
          vm.paginationDataProduct.currentPage = res.pageNo
          vm.paginationDataProduct.pageSize = res.pageSize
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
